import React from "react";

import { Icon } from "components/Icon";

import styled from "styled-components";

import { debounce } from "utils";
import CheckboxControl from "components/Form/CheckboxControl";


import { Form, InputGroup, InputNumber, SelectPicker } from "rsuite";

export default ({
    filters,
    account_manager_list,
    paymentTermsList,
    onChangeFilters,
}) => {
    return (
        <StyledForm
            formDefaultValue={filters}
            onChange={debounce((value) => {
                onChangeFilters(value);
            }, 500)}
        >
            <StyledFormControl
                accepter={SelectPicker}
                placeholder="Account manager"
                data={account_manager_list}
                labelKey="name"
                valueKey="id"
                name="account_manager_id"
                label="Account manager"
                searchable={false}
                errorPlacement="topRight"
                virtualized
            />

            <StyledFormControl
                accepter={SelectPicker}
                data={paymentTermsList}
                labelKey="name"
                valueKey="name"
                style={{ width: 224 }}
                placeholder="Payment term"
                name="payment_terms_name"
                searchable={false}
                errorPlacement="topRight"
            />
            <StyledFormGroup>
                <Form.ControlLabel>Minimal payment amount</Form.ControlLabel>
                <StyledMinimumPaymentField
                    // accepter={InputNumber}
                    name="minimum_payment"
                    // min={0}
                    // max={100000}
                    // step={0.1}
                    onChange={(value) => {
                        localStorage.setItem("PAYMENT_MANAGMENT_HAWALA_FILTER_MINIMUM_PAYMENT", value);
                    }}
                    errorPlacement="topRight"
                    placeholder="Payment"
                />
            </StyledFormGroup>
            <CheckboxControl
                name="show_closed_account"
                defaultChecked={false}
            >
                Show closed accounts
            </CheckboxControl>
        </StyledForm>
    );
};

const StyledForm = styled(Form)`
    && {
        width: 100%;
        display: flex;
    }
    .rs-form-control-wrapper {
        width: auto;
        margin-right: 20px;
    }
`;

const StyledFormControl = styled(Form.Control)`
    && {
        width: 100%;
        min-width: 200px;
        max-width: 220px;
        overflow: hidden;
    }
`;

const StyledFormGroup = styled(Form.Group)`
    && {
        display: flex;
        align-items: center;
        margin-bottom: 0px !important;

        .rs-form-control-label {
            margin-right: 10px;
            margin-bottom: 0px;
        }
    }
`;

const StyledMinimumPaymentField = styled(Form.Control)`
    && {
        min-width: 80px;
        max-width: 100px;
        overflow: hidden;
    }
`;